/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const getSyntheseDashboard = () => `${baseUrlApi}/individus/synthese`;
export const getStatistiquesDashboard = (annee) =>
  `${baseUrlApi}/individus/statistiques/${annee}`;
export const getDoyen = () => `${baseUrlApi}/individus/recenses/doyen`;
export const numerotationIndividu = () =>
  `${baseUrlApi}/individus/numerotation`;
export const denumerotationIndividu = () =>
  `${baseUrlApi}/individus/denumerotation`;
export const attestation = (identifiant) =>
  `${baseUrlApi}/individus/${identifiant}/attestation`;
export const notice = (identifiant) =>
  `${baseUrlApi}/individus/${identifiant}/notice`;
export const editions = (identifiant) =>
  `${baseUrlApi}/individus/${identifiant}/editions`;
